<template>
  <div class="grid-parts__wrap-inner-tools d-flex justify-content-center">
    <grid
      ref="grid"
      :config="gridConfig"
      class="no-grid-border"
      @handleCustomButtonGrid="handlerQuickRFQ"
    >
      <template v-slot:inner-tools>
        <grid-tool-controls
          :controls="gridControls"
          class="inner-tool-controls"
          @command="handleCommand"
        />
      </template>
    </grid>
    <editor
      :disabled="!isAllowToEditRFQs"
      :config="{id: gridConfig.id, api: 'RFQ2s/Get/'}"
      :editorID="editorID"
      :partID="partID"
      @on-quick-rfq="handlerQuickRFQ"
    />
  </div>
</template>

<script>
import gridConfig from './GridConfig'
import models from '@/components/Grid/models'
import { waitValue } from '@/utils/promises'

export default {
  name: 'LayoutGrid',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'grid-tool-controls': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/GridToolControls'),
    'editor': () => import(/* webpackChunkName: 'Parts' */ './Editor')
  },
  props: {
    partID: { required: true },
    editorID: { required: true }
  },
  watch: {
    'partID': {
      immediate: true,
      handler () {
        this.getGrid()
          .then((grid) => {
            if (this.partID) {
              grid.setFilters(`partID == ${this.partID}`)
              grid.loadData()
            }
          })
      }
    }
  },
  data () {
    return {
      gridConfig: gridConfig
    }
  },
  computed: {
    isAllowToEditRFQs () {
      return this.permission(this.$store.getters.get('permissions'), 'isAllowToEditRFQs')
    },
    gridControls () {
      return this.$_.merge(models.grid(this.$root).header.controls, {
        isRefresh: true,
        export: {
          json: {
            current: {
              isVisible: false
            },
            all: {
              isVisible: false
            }
          }
        },
        addNew: {
          isVisible: this.isAllowToEditRFQs
        }
      })
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs.grid)
    },
    handleCommand () {
      this.getGrid()
        .then((grid) => {
          grid.handleCommand(...arguments)
        })
    },
    handlerQuickRFQ ({ row }) {
      this.$emit('on-quick-rfq', { rfq2ID: row.id })
    }
  }
}
</script>
